import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  detailscont: {
    "& h2": {
      color: theme.palette.primary.main,
      marginBlock: "8px"
    }
  },
  syllabuscont: {
    background: "#F9FAFB",
    borderRadius: "24px",
    padding: "24px 21px",
    textAlign: "left",
    height: "225px",
    "& h3": {
      marginBlock: "8px"
    },
    "& ul": {
      listStyle: "inside",
      textAlign: "left",
      marginBlock: "8px"
    }
  },

  // --| Upload dropzone (shared shape with src/pages/resources/styles.js)
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: "24px 20px",
    marginBottom: 12,
    marginTop: 8
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadflex: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    textAlign: "center"
  },
  uploadicon: {
    fontSize: 28,
    color: "#155EEF"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontSize: 13,
    marginBottom: 0,
    marginTop: 4
  },
  fileChipList: {
    display: "flex",
    flexDirection: "column",
    gap: 8
  },
  fileChip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    border: "1px solid #EAECF0",
    borderRadius: 8,
    fontSize: 14
  },
  fileChipRemove: {
    cursor: "pointer",
    color: "#98A2B3"
  },

  // --| Empty states ("No Syllabus Yet", "No resources for this topic yet")
  emptyStateContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "64px 24px"
  },
  emptyStateIcon: {
    width: 72,
    height: 72,
    borderRadius: 16,
    background: "#EFF4FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 32,
    color: "#155EEF",
    marginBottom: 16
  },
  emptyStateTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#101928",
    margin: 0
  },
  emptyStateSubtitle: {
    color: "#667085",
    fontSize: 14,
    maxWidth: 340,
    marginTop: 4,
    marginBottom: 20
  },

  // --| Syllabus editor header
  editorHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 16
  },
  editorHeaderInfo: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap"
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "2px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600
  },
  statusBadgeDraft: {
    background: "#FFF6E5",
    color: "#B54708"
  },
  statusBadgePublished: {
    background: "#ECFDF3",
    color: "#027A48"
  },
  metaChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 12px",
    borderRadius: 8,
    border: "1px solid #EAECF0",
    fontSize: 13,
    color: "#344054"
  },

  // --| Week sidebar + topic list
  editorBody: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap"
  },
  weekSidebar: {
    minWidth: 220,
    flex: "0 0 220px",
    display: "flex",
    flexDirection: "column",
    gap: 10
  },
  weekItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #EAECF0",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#155EEF"
    }
  },
  weekItemActive: {
    background: "#155EEF",
    borderColor: "#155EEF",
    color: "#fff",
    "& $weekBadge": {
      background: "rgba(255,255,255,0.2)",
      color: "#fff"
    },
    "& $weekItemSubtitle": {
      color: "#EAECF0"
    }
  },
  weekBadge: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "#EFF4FF",
    color: "#155EEF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    fontWeight: 600,
    flexShrink: 0
  },
  weekItemTitle: {
    fontSize: 14,
    fontWeight: 600,
    margin: 0,
    textAlign: "left"
  },
  weekItemSubtitle: {
    fontSize: 12,
    color: "#667085",
    margin: 0,
    textAlign: "left"
  },
  weekPanel: {
    flex: "1 1 400px",
    minWidth: 280
  },
  topicRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "14px 16px",
    borderRadius: 10,
    border: "1px solid #EAECF0",
    marginBottom: 10
  },
  topicDragHandle: {
    cursor: "grab",
    color: "#98A2B3"
  },
  topicTitle: {
    fontSize: 14,
    fontWeight: 600,
    margin: 0,
    cursor: "pointer",
    textAlign: "left"
  },
  topicObjective: {
    fontSize: 12,
    color: "#667085",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left"
  },
  topicActions: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginLeft: "auto"
  },
  topicActionButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: 8,
    border: "1px solid #EAECF0",
    background: "#fff",
    color: "#667085",
    cursor: "pointer",
    padding: 0,
    fontSize: 16,
    "&:hover": {
      background: "#F9FAFB",
      color: "#101928"
    }
  },
  progressBadge: {
    fontSize: 12,
    fontWeight: 600,
    padding: "2px 10px",
    borderRadius: 20
  },
  progressCompleted: {
    background: "#ECFDF3",
    color: "#027A48"
  },
  progressInProgress: {
    background: "#EFF8FF",
    color: "#175CD3"
  },
  progressNotStarted: {
    background: "#F2F4F7",
    color: "#475467"
  },

  // --| Materials / Resources grids
  materialsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 16
  },
  materialCard: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "14px 16px",
    borderRadius: 10,
    border: "1px solid #EAECF0",
    cursor: "pointer"
  },
  materialIcon: {
    width: 40,
    height: 40,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    flexShrink: 0
  },
  materialTitle: {
    fontSize: 14,
    fontWeight: 600,
    margin: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  materialMeta: {
    fontSize: 12,
    color: "#667085",
    margin: 0,
    textAlign: "left"
  },
  materialActions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginLeft: "auto",
    color: "#98A2B3",
    "& svg": {
      cursor: "pointer"
    }
  },

  // --| Class / checkbox selectors
  checkboxList: {
    maxHeight: 220,
    overflowY: "auto",
    border: "1px solid #EAECF0",
    borderRadius: 8,
    padding: 12
  },
  checkboxItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 0"
  },
  chipList: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 10
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: 20,
    background: "#EFF4FF",
    color: "#155EEF",
    fontSize: 13
  },
  chipRemove: {
    cursor: "pointer"
  },

  modalFooterBtn: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    padding: "12px 4px"
  }
}));
